import template from './timeoutCountdown.html';
import controller from './timeoutCountdown.controller';
import './timeoutCountdown.scss';
let timeoutCountdown = {
  restrict: 'E',
  bindings: {
    modelDetails: '=',
    onConfirm: '=',
    onError: '=',
    event: '='
  },
  template,
  controller
};

export default timeoutCountdown;



// WEBPACK FOOTER //
// ./client/app/common/ui/timeoutCountdown/timeoutCountdown.component.js